import {
  UPCOMING_EVENT_COUNTDOWN_BACKGROUND_COLOR_TOKENS,
  UPCOMING_EVENT_COUNTDOWN_BACKGROUND_FALLBACK_COLORS
} from '@components/upcoming-event-countdown/upcoming-event-countdown.constants';

function getThemeColor(
  documentRef: Document,
  cssVariable: string,
  fallback: string
): string {
  return (
    getComputedStyle(documentRef.body).getPropertyValue(cssVariable).trim() ||
    fallback
  );
}

export function applyEventTicketingBackgroundTheme(
  svgText: string,
  documentRef: Document,
  isWhiteLabel: boolean = false
): string {
  const { ACCENT, GRADIENT_OVERLAY } =
    UPCOMING_EVENT_COUNTDOWN_BACKGROUND_COLOR_TOKENS;
  const fallbacks = UPCOMING_EVENT_COUNTDOWN_BACKGROUND_FALLBACK_COLORS;

  const cssVariable = isWhiteLabel ? '--configThemeColor' : '--configBgColor';

  const accentColor = getThemeColor(
    documentRef,
    cssVariable,
    fallbacks.accent
  );
  const gradientOverlayColor = getThemeColor(
    documentRef,
    '--configSecondaryBgColor',
    fallbacks.gradientOverlay
  );

  return svgText
    .split(ACCENT)
    .join(accentColor)
    .split(GRADIENT_OVERLAY)
    .join(gradientOverlayColor);
}
